import React from 'react';
import '../styles.css';

export default function Footer(){
    return(
        <footer className="footer">
            <p>Kanban</p>
        </footer>
    );
}